import { logger } from './common/logger';
import { isFontSyncMode } from './common/settings';

const checkConfigAndInit = async () => {
  let fontSyncModule = null;
  if (isFontSyncMode()) {
    fontSyncModule = await import('./features/fontSync');
    await fontSyncModule.checkAndLoadFontSync();
    logger.log('font-sync enabled');
  }

  const csvUploadModule = await import('./features/csvUpload');
  await csvUploadModule.checkAndDisplayCSVUpload({
    retryContainerCreation: true,
  });

  const popUpModule = await import('./features/LargeCartPopUp');
  await popUpModule.renderLargeCartPopup();

  const toastModule = await import('./features/toast');
  await toastModule.renderToast();
};

checkConfigAndInit();
